import { AccountDto } from '../../../interfaces/Dto/AccountDto';

export default function transformFormRequest(numberOfQuestions: number, request: unknown): AccountDto {
  const inputsMap = new Map(Object.entries(request));
  const questionNumbers = [] as number[];
  for (let i = 0; i < numberOfQuestions; i++) {
    questionNumbers.push(i + 1);
  }
  const username: string = null;
  const transformedRequest = {
    username,
    password: inputsMap.get('currentPassword'),
    userSecurityQuestions: questionNumbers.map((x) => ({
      active: true,
      question: undefined,
      code: inputsMap.get(`question${x}`),
      answer: inputsMap.get(`answer${x}`),
    })),
  };
  return transformedRequest;
}
